<template>
  <div class="adminaside" width="258px">
    <div class="fixed">
      <router-link to="/project" class="alogo"></router-link>
      <el-aside width="258px">
        <el-menu default-active="1" class="eldemo" @open="handleOpen" @close="handleClose" :router="true" :default-openeds="openeds">
          <el-menu-item index="/home" v-show="MenuInclude('1')">
            <i class="sideicon home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="1" v-show="MenuInclude('2')">
            <template slot="title">
              <i class="sideicon list"></i>
              <span slot="title">客户项目</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/project" v-show="MenuInclude('3')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/apply" v-show="MenuInclude('4')"><span>收款管理</span></el-menu-item>
              <el-menu-item index="/invoice" v-show="MenuInclude('5')"><span>发票管理</span></el-menu-item>
              <el-menu-item index="/purchase" v-show="MenuInclude('6')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/pay" v-show="MenuInclude('7')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2" v-show="MenuInclude('8')">
            <template slot="title">
              <i class="sideicon list"></i>
              <span slot="title">行政采购</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/admin" v-show="MenuInclude('9')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/adPurchase" v-show="MenuInclude('10')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/adPay" v-show="MenuInclude('11')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3" v-show="MenuInclude('12')">
            <template slot="title">
              <i class="sideicon list"></i>
              <span slot="title">人力资源</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/human" v-show="MenuInclude('13')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/hrPurchase" v-show="MenuInclude('14')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/hrPay" v-show="MenuInclude('15')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4" v-show="MenuInclude('16')">
            <template slot="title">
              <i class="sideicon list"></i>
              <span slot="title">个人事务管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/expense" v-show="MenuInclude('17')"><span>报销管理</span></el-menu-item>
              <el-menu-item index="/vacation"><span>休假管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="5" v-show="MenuInclude('19')">
            <template slot="title">
              <i class="sideicon list"></i>
              <span slot="title">客户/供应商管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/client" v-show="MenuInclude('20')"><span>客户管理</span></el-menu-item>
              <el-menu-item index="/vendor" v-show="MenuInclude('21')"><span>供应商管理</span></el-menu-item>
              <el-menu-item index="/pubcase" v-show="MenuInclude('414')"><span>供应商刊例</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="8">
            <template slot="title">
              <i class="sideicon biao"></i>
              <span slot="title">物品管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/assest"><span>物品管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="6" v-show="MenuInclude('22')">
            <template slot="title">
              <div class="onetitle">
                <i class="sideicon user"></i>
                <span>账号管理</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/author" v-show="MenuInclude('23')"><span>账号管理</span></el-menu-item>
              <el-menu-item index="/role" v-show="MenuInclude('24')"><span>职位管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="7" v-show="MenuInclude('25')">
            <template slot="title">
              <i class="sideicon say"></i>
              <span slot="title">其他管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/adminLog" v-show="MenuInclude('26')"><span>后台管理日志</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import store from '../store'

export default {
  name: 'adminaside',
  data() {
    return {
      menuLimtList: [],
      user: JSON.parse(localStorage.getItem('setUserInfo')) || {},
      bkUserArr: {},
      permissionList: [],
      lv: '',
      user_id: '',
      openeds: ['1', '2', '3', '4', '5', '8'],
      scrollTop: '',
    }
  },
  mounted() {
    this.getDetail(this.user.id)
  },
  computed: {
    _p() {
      return (id) => {
        return this.permissionList.includes(id) || this.lv == true
      }
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    p(id) {
      return this.permissionList.includes(id) || this.lv == true
    },
    getDetail(id) {
      api
        .getAccountDetail({
          uid: id,
        })
        .then((res) => {
          this.lv = res.bkUserArr.level
          this.user_id = res.bkUserArr.id
          this.menuLimtList = res.bkUserArr.role.menu_ids.split(',')
          store.commit('setLevel', this.lv)
          store.commit('setName', res.bkUserArr.realname)
          store.commit('setUserId', res.bkUserArr.id)
          store.commit('setMineHolidyData', res.bkUserArr.holiday)
          store.commit('setMenuLimtList', res.bkUserArr.role.menu_ids.split(','))
          if (res.bkUserArr.permissionList) {
            const permissionList = res.bkUserArr.permissionList || []
            this.permissionList = permissionList.map((item) => item.menu_id)
          }
          return res
        })
    },
    MenuInclude(val) {
      return this.menuLimtList.includes(val)
    },
  },
}
</script>

<style lang="scss">
.sideicon {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: contain;
  margin-right: 10px;

  &.home {
    background-image: url(../assets/images/home.png);
  }

  &.biao {
    background-image: url(../assets/images/biao.png);
  }

  &.list {
    background-image: url(../assets/images/list.png);
  }

  &.more {
    background-image: url(../assets/images/more.png);
  }

  &.say {
    background-image: url(../assets/images/say.png);
  }

  &.user {
    background-image: url(../assets/images/user.png);
  }

}

.el-aside {
  scrollbar-width: none;
}

.el-aside::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}


.adminaside {
  width: 258px;
  height: 100vh;
  position: relative;
  padding-top: 30px;

  .fixed {
    width: 258px;
    position: fixed;

    .alogo {
      width: 154px;
      height: 18px;
      display: block;
      margin: 0 auto 30px;
      background: url(../assets/alogo.png) no-repeat;
      background-size: contain;
    }

    .el-aside {
      width: 258px;
      height: calc(100vh - 88px);
      overflow-y: scroll;
    }

    .el-submenu__title {
      border-bottom: 1px solid rgba(#d7d7d7, 0.3);
      font-size: 16px;
    }

    .el-menu {
      border-right: none;

      .el-menu-item-group__title {
        padding: 0;
      }

      .el-menu-item {
        background: $c;
        color: #fff;
        font-size: 16px;
        border-bottom: 1px solid rgba(#d7d7d7, 0.3);
      }
    }

    .el-submenu.is-opened {
      .el-submenu__title {
        background: rgba($color: #0E0F22, $alpha: 0.95);
        color: #fff;
        border-bottom: 1px solid rgba(#d7d7d7, 0.3);

        i {
          color: #fff;
        }
      }

      .el-menu .el-menu-item {
        background: rgba($color: #0E0F22, $alpha: 0.85);
        color: #fff;
        border-bottom: 1px solid rgba(#fff, 0);

        span {
          font-size: 14px;
        }

        &.is-active {
          span {
            border-bottom: 1px solid #ffffff;
          }
        }
      }
    }

    .el-submenu__title,
    .el-submenu__title:hover {
      background: $c;
      color: #fff;

      i {
        color: #fff;
      }

      border-bottom-color: rgba(#d7d7d7, 0.3);
    }
  }
}
</style>
